import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings<{
  title: string;
  createAccountLinkLabel: string;
  feedback: string;
}>({
  en: {
    createAccountLinkLabel: 'Create a wallet',
    feedback: 'Give us your feedback',
    title: 'Accounts',
  },
  fr: {
    createAccountLinkLabel: 'Créer un sous‑compte',
    feedback: 'Faites-nous vos retours',
    title: 'Comptes',
  },
} as const);

export default locales;
